 // DEFINE GLOBAL FUNCTIONS FIRST - before any other code
  
  // Global function declarations
  let bundleBuilder;
  let popupVariantId;
  let popupProductId;

  window.addToBundle = function(element) {
    try {
      if (!bundleBuilder && !window.bundleBuilder) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      const builderInstance = bundleBuilder || window.bundleBuilder;
      
      // Check if we're at the 5-item limit
      const currentItemCount = builderInstance.getTotalItemCount();
      if (currentItemCount >= 5) {
        showBundleLimitMessage(true);
        return;
      }
      
      const selectedVariantInfo = getSelectedVariantInfo(element);

      const variant = new Variant(selectedVariantInfo.variantId, selectedVariantInfo.productImage, selectedVariantInfo.productTitle, selectedVariantInfo.productId, selectedVariantInfo.variantTitle, selectedVariantInfo.variantPrice, selectedVariantInfo.hasOnlyDefaultVariant);
      const bundleItem = new BundleItem(variant, 1);
      builderInstance.addBundleItem(bundleItem);

      updateAllBundleBuilderDoms();
      updateSelectedProductImages();
      updateProductLimitStates();
      
      // Hide the message when successfully adding (if it was showing)
      showBundleLimitMessage(false);
    } catch (error) {
      console.error('Error in addToBundle:', error);
    }
  };

  window.increaseQuantity = function(element) {
    try {
      if (!bundleBuilder && !window.bundleBuilder) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      const builderInstance = bundleBuilder || window.bundleBuilder;
      
      // Check if we're at the 5-item limit
      const currentItemCount = builderInstance.getTotalItemCount();
      if (currentItemCount >= 5) {
        showBundleLimitMessage(true);
        return;
      }
      
      const selectedVariantInfo = getSelectedVariantInfo(element);
      const bundleItem = builderInstance.getBundleItem(selectedVariantInfo.variantId);

      if (!bundleItem) return;

      bundleItem.quantity = bundleItem.quantity + 1;
      updateAllBundleBuilderDoms();
      updateSelectedProductImages();
      updateProductLimitStates();
      
      // Hide the message when successfully adding
      showBundleLimitMessage(false);
    } catch (error) {
      console.error('Error in increaseQuantity:', error);
    }
  };

  window.decreaseQuantity = function(element) {
    try {
      if (!bundleBuilder && !window.bundleBuilder) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      const builderInstance = bundleBuilder || window.bundleBuilder;
      const selectedVariantInfo = getSelectedVariantInfo(element);
      const bundleItem = builderInstance.getBundleItem(selectedVariantInfo.variantId);

      if (!bundleItem) return;

      bundleItem.quantity = bundleItem.quantity - 1;
      if (bundleItem.quantity === 0) {
        builderInstance.items.delete(selectedVariantInfo.variantId);
      }
      updateAllBundleBuilderDoms();
      updateSelectedProductImages();
      updateProductLimitStates();
      
      // Hide the message when removing items
      showBundleLimitMessage(false);
    } catch (error) {
      console.error('Error in decreaseQuantity:', error);
    }
  };

  window.removeVariant = function(element) {
    try {
      if (!bundleBuilder && !window.bundleBuilder) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      const builderInstance = bundleBuilder || window.bundleBuilder;
      const variantId = element.dataset.id;
      builderInstance.items.delete(variantId);
      updateAllBundleBuilderDoms();
      updateSelectedProductImages();
      updateProductLimitStates();
      
      // Hide the message when removing items
      showBundleLimitMessage(false);
    } catch (error) {
      console.error('Error in removeVariant:', error);
    }
  };

  window.selectVariant = function(element) {
    try {
      const parentDocument = element.parentNode;
      parentDocument.querySelectorAll('.main-bundle-product-variant').forEach(element => {
        element.classList.remove('active');
      });
      element.classList.add('active');
      
      // Update the price display immediately
      const priceContainer = element.closest('.main-bundle-product-card-container');
      const priceElement = priceContainer.querySelector('.main-bundle-product-price');
      const variantPrice = element.dataset.variantPrice; // This should be the formatted price like "$25.00"
      
      if (priceElement && variantPrice) {
        priceElement.innerHTML = variantPrice;
      }
      
      // Update the add/remove button states for this specific variant
      const card = element.closest('.main-bundle-product-card');
      if (card) {
        updateBundleProductCardDom(card);
        
        // Check if we need to update limit states when variant changes
        const builderInstance = bundleBuilder || window.bundleBuilder;
        if (builderInstance) {
          const variantId = element.dataset.id;
          const bundleItem = builderInstance.getBundleItem(variantId);
          const currentItemCount = builderInstance.getTotalItemCount();
          
          // If we're at limit and this variant is not in bundle, disable the add button
          if (currentItemCount >= 5 && !bundleItem) {
            const addButton = card.querySelector('.main-bundle-product-add-to-bundle');
            addButton.style.opacity = '0.5';
            addButton.style.pointerEvents = 'none';
          } else {
            const addButton = card.querySelector('.main-bundle-product-add-to-bundle');
            addButton.style.opacity = '1';
            addButton.style.pointerEvents = 'auto';
          }
        }
      }
    } catch (error) {
      console.error('Error in selectVariant:', error);
    }
  };

  window.selectPopupVariant = function(element) {
    try {
      const parentDocument = element.parentNode;
      parentDocument.querySelectorAll('.bundle-builder-product-variant').forEach(element => {
        element.classList.remove('active');
      });
      element.classList.add('active');
      
      // Update the popup price display
      const priceContainer = element.closest('.bundle-builder-product-content');
      const priceElement = priceContainer.querySelector('.bundle-builder-product-price');
      const variantPrice = element.dataset.variantPrice;
      
      if (priceElement && variantPrice) {
        priceElement.innerHTML = variantPrice;
      }
      
      popupVariantId = element.dataset.id;
    } catch (error) {
      console.error('Error in selectPopupVariant:', error);
    }
  };

  window.toggleSelectedProduct = function(element) {
    try {
      element.closest('.main-bundle-selected-products').classList.toggle('show');
    } catch (error) {
      console.error('Error in toggleSelectedProduct:', error);
    }
  };

  window.filterProduct = function(element) {
    try {
      const attribute = `is-filter-${element.dataset.id}`;

      document.querySelectorAll('.main-bundle-product-card').forEach((element) => {
        element.classList.remove('hidden');
      })

      document.querySelectorAll(`.main-bundle-product-card[${attribute}="false"]`).forEach((element) => {
        element.classList.add('hidden');
      })

      document.querySelectorAll('.main-bundle-filter-item').forEach((element) => {
        element.classList.remove('active');
      })

      element.classList.add('active');
    } catch (error) {
      console.error('Error in filterProduct:', error);
    }
  };

  window.bundleBuilderCheckout = function() {
    try {
      const builderInstance = bundleBuilder || window.bundleBuilder;
      if (!builderInstance) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      builderInstance.addToCart().then(result => {
        if (!window.customElements.get("cart-drawer")) {
          window.customElements.define("cart-drawer", CartDrawer);
        }

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.setAttribute("open", "");
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          cartDrawer.style.display = "block";
        }
      });
    } catch (error) {
      console.error('Error in bundleBuilderCheckout:', error);
    }
  };

  window.fetchProductSection = async function(productHandle) {
    try {
      let result = await fetch(`/products/${productHandle}?section_id=bundle-builder-product`);
      result = await result.text();
      return result;
    } catch (err) {
      console.log(err);
      return '';
    }
  };

//   window.showProductDetail = async function(element) {
//     try {
//       // Body scroll lock
//       document.querySelector('body').classList.add('scroll-disable');

//       // Get product info
//       const productId = element.dataset.product;
//       const selectedVariantInfo = getSelectedVariantInfo(element);
//       popupVariantId = selectedVariantInfo.variantId;
//       popupProductId = selectedVariantInfo.productId;

//       // Fetch product section
//       const result = await fetchProductSection(selectedVariantInfo.productHandle);

//       // Update content
//       const viewProduct = document.querySelector('.main-bundle-view-product');
//       viewProduct.innerHTML = ''; // Clear existing content
      
//       // Create temporary container to parse HTML string
//       const tempContainer = document.createElement('div');
//       tempContainer.innerHTML = result;
//       const children = Array.from(tempContainer.children);
//       for (const child of children) {
//         viewProduct.appendChild(child);
//       }

//       updateProductPopup();

//       // Show overlay
//       document.querySelector('.main-bundle-view-product-overlay').classList.add('active');

//       // Handle Trustpilot widgets
//       const trustpilotWidgets = document.querySelectorAll('.bundle-builder-product-review .trustpilot-widget');
//       for (const widget of trustpilotWidgets) {
//         Trustpilot.loadFromElement(widget, () => {
//           console.log('Trustpilot widget reloaded!');
//         });
//       }

//       // Add click handlers
//       const addToBundleButton = document.querySelector('.bundle-builder-product-add-to-bundle');
//       if (addToBundleButton) {
//         addToBundleButton.addEventListener('click', function() {
//           const productId = this.closest('.bundle-builder-product-content').dataset.product;
//           const productCard = document.querySelector(`.main-bundle-product-card[data-product="${productId}"]`);
//           const addButton = productCard.querySelector('.main-bundle-product-add-to-bundle');
          
//           // Simulate click
//           addButton.click();
          
//           // Close overlay and enable scroll
//           document.querySelector('.main-bundle-view-product-overlay').classList.remove('active');
//           document.querySelector('body').classList.remove('scroll-disable');
//         });
//       }

//       // Remove from bundle handler
//       const removeButton = document.querySelector('.bundle-builder-product-remove .product-remove');
//       if (removeButton) {
//         removeButton.addEventListener('click', function() {
//           const productId = this.closest('.bundle-builder-product-content').dataset.product;
//           const productCard = document.querySelector(`.main-bundle-product-card[data-product="${productId}"]`);
//           const removeProductButton = productCard.querySelector('.main-bundle-product-remove .product-remove');
          
//           // Simulate click
//           removeProductButton.click();
          
//           // Close overlay and enable scroll
//           document.querySelector('.main-bundle-view-product-overlay').classList.remove('active');
//           document.querySelector('body').classList.remove('scroll-disable');
//         });
//       }

//     } catch (error) {
//       console.error('Error in showProductDetail:', error);
//     }
//   };

  window.closeProductDetail = function() {
    document.querySelector('.main-bundle-view-product-overlay').classList.remove('active');
    popupVariantId = null;
    popupProductId = null;
    document.querySelector('body').classList.remove('scroll-disable');
  };

  // NOW DEFINE THE CLASSES AND OTHER CODE

  class Variant {
    constructor(variantId, productImage, productTitle, productId, variantTitle, variantPrice, hasOnlyDefaultVariant) {
      this.variantId = variantId;
      this.productImage = productImage;
      this.productTitle = productTitle;
      this.productId = productId;
      this.variantTitle = variantTitle;
      this.variantPrice = variantPrice;
      this.hasOnlyDefaultVariant = hasOnlyDefaultVariant;
    }
  }

  class BundleItem {
    constructor(variant, quantity) {
      this.variant = variant;
      this.quantity = quantity;
    }

    generateBundleSelectedProductDom = () => {
      return `<div class="main-bundle-selected-product">
        <div class="main-bundle-selected-product-image">
          <img src="${this.variant.productImage}" alt="${this.variant.productTitle}">
          <div class="main-bundle-selected-product-number">${this.quantity}</div>
        </div>
        <div class="main-bundle-selected-product-content">
          <div class="main-bundle-selected-product-title">${this.variant.productTitle} ${this.variant.hasOnlyDefaultVariant === 'false' ? '- ' + this.variant.variantTitle : ''}</div>
          <div class="main-bundle-selected-product-remove" data-id="${this.variant.variantId}" data-product="${this.variant.productId}" onclick="removeVariant(this)">Remove</div>
        </div>
      </div>`;
    }
  }

  class BundleBuilder {
    constructor() {
      this.items = new Map();
      this.discountRule = [0, 5, 10, 15];
    }

    /**
     * Add the bundleItem at the bundle builder
     * @param {BundleItem} bundleItem Bundleitem Info
     */
    addBundleItem = (bundleItem) => {
      this.items.set(bundleItem.variant.variantId, bundleItem);
    }

    updateBundleItem = (variantId, quantity) => {
      let bundleItem = this.items.get(variantId);

      if (!bundleItem) return;
      bundleItem.quantity = quantity;
    }

    getBundleItem = (variantId) => {
      return this.items.get(variantId);
    }

    getBundleItemByProductId = (productId) => {
      for (let [variantId, bundleItem] of this.items) {
        if (bundleItem.variant.productId === productId) {
          return bundleItem;
        }
      }
      return null;
    }

    /**
     * Generetate the DOM HTML string
     * @returns the DOM HTML string with the selected products
     */
    generateBundleSelectedProductsDom = (isMobile) => {
      let result = '';

      if (isMobile) {
        result = result + `<div class="main-bundle-selected-products-heading" onclick=toggleSelectedProduct(this)>
          <p>You have ${this.getTotalItemCount()} item(s) in your bundle</p>
        //   <img src="{{ 'icon-arrow.svg' | asset_url }}" alt="arrow">
        </div>`;
      }

      this.items.forEach((item) => {
        result = result + item.generateBundleSelectedProductDom();
      })

      return result;
    }

    getOriginPrice = () => {
      let result = 0;

      this.items.forEach((item) => {
        result = result + item.variant.variantPrice * item.quantity;
      });

      return result;
    }

    getTotalItemCount = () => {
      let total_item_count = 0;

      this.items.forEach((item) => {
        total_item_count = total_item_count + item.quantity;
      })

      return total_item_count;
    }

    getDiscountPercentage = () => {
      const total_item_count = this.getTotalItemCount();

      if (total_item_count > 3) {
        return this.discountRule[3];
      } else {
        return this.discountRule[total_item_count - 1];
      }
    }

    getFinalPrice = () => {
      return this.getOriginPrice() * (100 - this.getDiscountPercentage()) / 100;
    }

    getSavingPrice = () => {
      return this.getOriginPrice() - this.getFinalPrice();
    }

    addToCart = async () => {
      try {
        let result = await getCartItems();
        if (!result) return null;

        const keys = [];
        result.items.forEach((item) => {
          if (item.properties['__bundle_builder_product']) {
            keys.push(item.key);
          }
        });

        let updates = {};

        keys.forEach((key) => {
          updates[key] = 0;
        })

        result = await updateCart(updates);
        if(!result) return null;

        const items = [];
  
        this.items.forEach((item) => {
          items.push({
            quantity: item.quantity,
            id: item.variant.variantId,
            properties: {
              "__bundle_builder_product": "yes"
            }
          })
        })
  
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items
          })
        });
        return true;
      } catch (err) {
        console.log(err)
        return false;
      }
    }
  }

  bundleBuilder = new BundleBuilder();
  window.bundleBuilder = bundleBuilder; // Also assign to window for backup

  const getSelectedVariantInfo = (element) => {
    const document = element.closest('.bundle-product');
    const variantId = document.querySelector('.bundle-product-variant.active').dataset.id;
    const productImage = document.querySelector('.bundle-product-variant.active').dataset.image;
    const productTitle = document.querySelector('.bundle-product-variant.active').dataset.title;
    const productId = document.querySelector('.bundle-product-variant.active').dataset.product;
    const variantTitle = document.querySelector('.bundle-product-variant.active').dataset.variant;
    const variantPrice = document.querySelector('.bundle-product-variant.active').dataset.price;
    const productHandle = document.querySelector('.bundle-product-variant.active').dataset.handle;
    const hasOnlyDefaultVariant = document.querySelector('.bundle-product-variant.active').dataset.only;

    return {
      variantId, productImage, productTitle, productId, variantTitle, variantPrice, hasOnlyDefaultVariant, productHandle
    };
  }

  const updateBundleProductCardDom = (element) => {
    const selectedVariantInfo = getSelectedVariantInfo(element);
    const bundleItem = bundleBuilder.getBundleItem(selectedVariantInfo.variantId);
    
    if (!bundleItem) {
      element.querySelector('.main-bundle-product-add-to-bundle').classList.add('active');
      element.querySelector('.main-bundle-product-remove').classList.remove('active');
      element.classList.remove('active', 'deactive');
      return;
    }
    
    const bundleQuantity = bundleItem.quantity;

    if (bundleQuantity > 0) {
      element.querySelectorAll('.main-bundle-product-variant').forEach(variantElement => {
        if (variantElement.dataset.id === bundleItem.variant.variantId) {
          variantElement.classList.add('active');
        } else {
          variantElement.classList.remove('active');
        }
      });
      element.querySelector('.main-bundle-product-add-to-bundle').classList.remove('active');
      element.querySelector('.main-bundle-product-remove').classList.add('active');
      element.classList.add('active');
    } else {
      element.querySelector('.main-bundle-product-add-to-bundle').classList.add('active');
      element.querySelector('.main-bundle-product-remove').classList.remove('active');
      element.classList.remove('active', 'deactive');
    }
  }

  const updateBundleProductCardsDom = () => {
    document.querySelectorAll('.main-bundle-product-card').forEach((element) => {
      updateBundleProductCardDom(element);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Remove any existing event listeners on variants
    document.querySelectorAll('.main-bundle-product-variant').forEach(element => {
      // Clone the element to remove all event listeners
      const newElement = element.cloneNode(true);
      element.parentNode.replaceChild(newElement, element);
    });
    
    // Add the proper event listeners
    document.querySelectorAll('.main-bundle-product-variant').forEach(element => {
      element.addEventListener('click', function() {
        // Call the global selectVariant function
        selectVariant(this);
      });
    });
  });

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  const updateCheckoutDom = () => {
    const desktopDoc = document.querySelector('.routine_total');
    const mobileDoc = document.querySelector('.main-bundle-mobile-sticky-container .main-bundle-checkout-container');
    const desktopDoc1 = document.querySelector('.sticky_bundle_checkout');
    if (bundleBuilder.items.size === 0) {
      desktopDoc.querySelector('.main-bundle-subtotal-final-price').innerHTML = `${formatMoney('0', currencyFormat)}`;
      desktopDoc.querySelector('.main-bundle-subtotal-save-text').innerHTML = `Add items to start saving!`;
    } else {
      const originPrice = (bundleBuilder.getOriginPrice() / 100).toFixed(2);
      const finalPrice = (bundleBuilder.getFinalPrice() / 100).toFixed(2);
      const savingPrice = (bundleBuilder.getSavingPrice() / 100).toFixed(2);

      if (savingPrice != 0) {
        desktopDoc.querySelector('.main-bundle-subtotal-save-text').innerHTML = `You've saved ${formatMoney(savingPrice, currencyFormat)}!`;
        desktopDoc.querySelector('.main-bundle-subtotal-origin-price').innerHTML = `${formatMoney(originPrice, currencyFormat)}`;
        desktopDoc.querySelector('.main-bundle-subtotal-save-text').classList.add('active');
        desktopDoc.querySelector('.main-bundle-subtotal-origin-price').classList.add('active');
      } else {
        desktopDoc.querySelector('.main-bundle-subtotal-save-text').innerHTML = `Add items to start saving!`;
        desktopDoc.querySelector('.main-bundle-subtotal-origin-price').classList.remove('active');
      }
      
      desktopDoc.querySelector('.main-bundle-subtotal-final-price').innerHTML = `${formatMoney(finalPrice, currencyFormat)}`;

      desktopDoc.classList.add('active');
    }
  }

  updateAllBundleBuilderDoms = () => {
    updateBundleProductCardsDom();
    updateCheckoutDom();
    updateProductPopup();
    updateProductLimitStates();
  }

  const getCartItems = async () => {
    try {
      let result = await fetch('/cart.js');

      result = await result.json();

      return result;
    } catch (err) {
      console.log(err)
      return null;
    }
  }

  const updateCart = async (updates) => {
    try {
      let result = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates
        })
      });
  
      result = await result.json();
      return result;
    
    } catch (err) {
      console.log(err);
      return null;
    }
  } 

  getCartItems().then((cart) => {
    if (cart) {
      const cartItems = cart.items;
      cartItems.forEach((item) => {
        if (item.properties['__bundle_builder_product']) {
          const variant = new Variant(item.variant_id.toString(), item.image, item.product_title, item.product_id.toString(), item.variant_title, item.price.toString(), item.product_has_only_default_variant.toString());
  
          const bundleItem = new BundleItem(variant, item.quantity);
  
          bundleBuilder.addBundleItem(bundleItem);
        }
      })
      updateAllBundleBuilderDoms();
      updateSelectedProductImages();
      updateProductLimitStates();
    }
  });

  const updateProductPopup = () => {
    if (popupVariantId && popupProductId) {
      const popupBundleItem = bundleBuilder.getBundleItem(popupVariantId);
      
      addReviewAtPopup(popupProductId);

  
      document.querySelector(`.bundle-builder-product-variant[data-id="${popupVariantId}"]`).classList.add('active');
  
      if (!popupBundleItem) {
        document.querySelector('.bundle-builder-product-add-to-bundle').classList.add('active');
        document.querySelector('.bundle-builder-product-remove').classList.remove('active');
        return;
      };
  
      const bundleQuantity = popupBundleItem.quantity;
  
      if (bundleQuantity > 0) {
        document.querySelector('.bundle-builder-product-add-to-bundle').classList.remove('active');
        document.querySelector('.bundle-builder-product-remove').classList.add('active');
      } else {
        document.querySelector('.bundle-builder-product-add-to-bundle').classList.add('active');
        document.querySelector('.bundle-builder-product-remove').classList.remove('active');
      }
    }
  }

  const addReviewAtPopup = (productId) => {
    document.querySelector('.main-bundle-view-product-overlay .bundle-builder-product-review').innerHTML = document.querySelector(`.main-bundle-product-card[data-product="${productId}"] .main-bundle-product-reviews`).innerHTML;
  }

  window.addEventListener('load', () => {
    updateSelectedProductImages();
    updateProductLimitStates();
  });

  function getNextAvailableStepSlot() {
    const stepBlocks = document.querySelectorAll('.steps_block .step');
    for (let i = 0; i < stepBlocks.length; i++) {
      const stepInfo = stepBlocks[i].querySelector('.step_info');
      if (stepInfo && stepInfo.innerHTML.trim() === '<p>+</p>') {
        return i;
      }
    }
    return -1;
  }

  function findStepSlotByProductId(productId) {
    const stepBlocks = document.querySelectorAll('.steps_block .step');
    for (let i = 0; i < stepBlocks.length; i++) {
      const stepInfo = stepBlocks[i].querySelector('.step_info');
      const img = stepInfo.querySelector('img');
      if (img) {
        const stepSlot = stepBlocks[i];
        if (stepSlot.dataset.productId === productId) {
          return i;
        }
      }
    }
    return -1;
  }

  function updateStepSlotsDisplay() {
    const stepBlocks = document.querySelectorAll('.steps_block .step');
    stepBlocks.forEach((stepBlock, index) => {
      const stepInfo = stepBlock.querySelector('.step_info');
      const stepName = stepBlock.querySelector('.step_name');
        stepInfo.innerHTML = '<p>+</p>';
      stepName.style.color = '#c8c8c8';
      stepBlock.removeAttribute('data-variant-id');
    });

    let slotIndex = 0;
    bundleBuilder.items.forEach((bundleItem, variantId) => {
      if (slotIndex < stepBlocks.length) {
        const stepBlock = stepBlocks[slotIndex];
        const stepInfo = stepBlock.querySelector('.step_info');
        const stepName = stepBlock.querySelector('.step_name');
        
        stepInfo.innerHTML = `<img src="${bundleItem.variant.productImage}" alt="Product Image" class="step-product-image">
        <div class="step-remove-btn" onclick="removeFromStepSlot(this)">×</div>`;
        stepName.style.color = '#000000';
        stepBlock.setAttribute('data-variant-id', variantId);
        slotIndex++;
      }
    });
  }

  document.querySelectorAll('.main-bundle-product-remove').forEach(removeButton => {
    removeButton.addEventListener('click', (event) => {
      setTimeout(() => {
        updateStepSlotsDisplay();
    updateProductCountAndButtons();
      }, 10);
  });
});

  document.querySelectorAll('.main-bundle-product-add-to-bundle').forEach(addButton => {
    addButton.addEventListener('click', (event) => {
      setTimeout(() => {
        updateStepSlotsDisplay();
        updateProductCountAndButtons();
      }, 10);
    });
  });

  const originalUpdateAllBundleBuilderDoms = updateAllBundleBuilderDoms;
  updateAllBundleBuilderDoms = () => {
    originalUpdateAllBundleBuilderDoms();
    updateStepSlotsDisplay();
    updateProductCountAndButtons();
  }

  window.addEventListener('load', () => {
    updateStepSlotsDisplay();
    updateProductCountAndButtons();
  });

  const originalRemoveVariant = removeVariant;
  removeVariant = (element) => {
    originalRemoveVariant(element);
    updateStepSlotsDisplay();
    updateProductCountAndButtons();
  }

  const originalAddToBundle = addToBundle;
  addToBundle = (element) => {
    originalAddToBundle(element);
    updateStepSlotsDisplay();
    updateProductCountAndButtons();
  }

  document.querySelectorAll('.product-remove').forEach(button => {
    button.addEventListener('click', function () {
      const productCard = this.closest('.main-bundle-product-card');
      const productId = productCard.dataset.product;
      document.querySelectorAll(`.main-bundle-product-card[data-product="${productId}"] .product-remove`)
        .forEach(matchingButton => {
          if (matchingButton !== this) {
            matchingButton.click();
          }
        });
      
      setTimeout(() => {
        updateStepSlotsDisplay();
        updateProductCountAndButtons();
      }, 10);
    });
  });

  // Add this new global function for removing from step slots
  window.removeFromStepSlot = function(element) {
    try {
      if (!bundleBuilder && !window.bundleBuilder) {
        console.error('bundleBuilder not initialized yet');
        return;
      }
      
      const builderInstance = bundleBuilder || window.bundleBuilder;
      const stepBlock = element.closest('.step');
      const variantId = stepBlock.getAttribute('data-variant-id');
      
      if (variantId) {
        builderInstance.items.delete(variantId);
        
        updateAllBundleBuilderDoms();
        updateSelectedProductImages();
        updateProductLimitStates();
        
        // Hide the message when removing items
        showBundleLimitMessage(false);
      }
    } catch (error) {
      console.error('Error in removeFromStepSlot:', error);
    }
  };

  function updateSelectedProductImages() {
    // Use the properly initialized bundleBuilder
    const builderInstance = bundleBuilder || window.bundleBuilder;
    if (!builderInstance) {
      console.error('bundleBuilder not initialized in updateSelectedProductImages');
      return;
    }

    // Clear all step slots first
    const stepBlocks = document.querySelectorAll('.steps_block .step');
    stepBlocks.forEach((stepBlock, index) => {
      const stepInfo = stepBlock.querySelector('.step_info');
      const stepName = stepBlock.querySelector('.step_name');
      stepInfo.innerHTML = '<p>+</p>';
      stepInfo.classList.remove('has-product');
      stepName.style.color = '#c8c8c8';
      stepBlock.removeAttribute('data-variant-id');
    });

    // Fill slots with selected products
    let slotIndex = 0;
    builderInstance.items.forEach((bundleItem, variantId) => {
      // For each product, add multiple slots if quantity > 1
      for (let i = 0; i < bundleItem.quantity; i++) {
        if (slotIndex < stepBlocks.length) {
          const stepBlock = stepBlocks[slotIndex];
          const stepInfo = stepBlock.querySelector('.step_info');
          const stepName = stepBlock.querySelector('.step_name');
          
          // Add the product image and remove button
          stepInfo.innerHTML = `
            <img src="${bundleItem.variant.productImage}" alt="Product Image" class="step-product-image">
            <div class="step-remove-btn" onclick="removeFromStepSlot(this)">×</div>
          `;
          
          stepInfo.classList.add('has-product');
          stepName.style.color = '#000000';
          stepBlock.setAttribute('data-variant-id', variantId);
          slotIndex++;
      }
    }
  });

    // Update the count and buttons
    updateProductCountAndButtons();
  }

  // Update the existing remove button event listeners to also update step slots
  document.querySelectorAll('.main-bundle-product-remove').forEach(removeButton => {
    removeButton.addEventListener('click', (event) => {
      // Update displays after removal
      setTimeout(() => {
        updateSelectedProductImages();
      }, 10);
            });
    });

  // Update the existing product remove synchronization
document.querySelectorAll('.product-remove').forEach(button => {
    button.addEventListener('click', function () {
        const productCard = this.closest('.main-bundle-product-card');
        const productId = productCard.dataset.product;
        document.querySelectorAll(`.main-bundle-product-card[data-product="${productId}"] .product-remove`)
            .forEach(matchingButton => {
                if (matchingButton !== this) {
                    matchingButton.click();
                }
            });
          
          // Update display after removal
          setTimeout(() => {
            updateSelectedProductImages();
          }, 10);
  });
});

  function updateProductCountAndButtons() {
    const builderInstance = bundleBuilder || window.bundleBuilder;
    if (!builderInstance) {
      console.error('bundleBuilder not initialized in updateProductCountAndButtons');
      return;
    }

    // Count actual products in bundle with their quantities
    let selectedProductsCount = 0;
    
    builderInstance.items.forEach((bundleItem) => {
      selectedProductsCount += bundleItem.quantity;
    });
    
    const completeBtnCount = document.querySelector('.complete_btn span');
    if (completeBtnCount) {
      completeBtnCount.innerHTML = `${selectedProductsCount}`;
    }
    
    const completeBtn = document.querySelector('.complete_btn');
    const checkoutBtn = document.querySelector('.main-bundle-checkout-button');
    const routineTitle = document.querySelector('.sticky_bundle_checkout .build_remaining_title');
    const routineTitleComplete = document.querySelector('.sticky_bundle_checkout .build_complate_title');
    const routineTitleMobile = document.querySelector('.sticky_bundle_steps .build_remaining_title');
    const routineTitleCompleteMobile = document.querySelector('.sticky_bundle_steps .build_complate_title');

    if (selectedProductsCount >= 3) {
      completeBtn.style.display = 'none';
      checkoutBtn.style.display = 'flex';
      routineTitle.style.display = 'none';
      routineTitleComplete.style.display = 'block';
      routineTitleMobile.style.display = 'none';
      routineTitleCompleteMobile.style.display = 'block';
    } else {
      completeBtn.style.display = 'flex';
      checkoutBtn.style.display = 'none';
      routineTitle.style.display = 'block';
      routineTitleComplete.style.display = 'none';
      routineTitleMobile.style.display = 'block';
      routineTitleCompleteMobile.style.display = 'none';
    }
  }

  // Add new function to handle product limit states
  function updateProductLimitStates() {
    const builderInstance = bundleBuilder || window.bundleBuilder;
    if (!builderInstance) {
      console.error('bundleBuilder not initialized in updateProductLimitStates');
      return;
    }

    const currentItemCount = builderInstance.getTotalItemCount();
    const isAtLimit = currentItemCount >= 5;
    
    // Get all product cards
    const productCards = document.querySelectorAll('.main-bundle-product-card');
    
    productCards.forEach(card => {
      const productId = card.dataset.product;
      
      // Check if this product (any variant) is already in the bundle
      const hasVariantInBundle = Array.from(builderInstance.items.values()).some(bundleItem => 
        bundleItem.variant.productId === productId
      );
      
      // If at limit and this product doesn't have any variants in bundle, disable it
      if (isAtLimit && !hasVariantInBundle) {
        card.classList.add('limit-reached');
      } else {
        card.classList.remove('limit-reached');
      }
    });
  }

  // Add function to show/hide the limit message
  function showBundleLimitMessage(show = true) {
    const messageElement = document.getElementById('bundleLimitMessage');
    if (messageElement) {
      if (show) {
        messageElement.style.display = 'block';
        // Auto-hide after 5 seconds
        setTimeout(() => {
          messageElement.style.display = 'none';
        }, 5000);
      } else {
        messageElement.style.display = 'none';
      }
    }
  }